import type { KillGrowthClass } from './api';

// Shared by the R4 kill-growth page and the player-hub Stats card.
export const KILL_GROWTH_CLASS_META: Record<
  KillGrowthClass,
  { label: string; sub: string; color: string; chip: string }
> = {
  rising: {
    label: 'Rising',
    sub: 'bottom third by power',
    color: '#34d399',
    chip: 'border-emerald-700/70 bg-emerald-900/30 text-emerald-200',
  },
  mid: {
    label: 'Mid',
    sub: 'middle third by power',
    color: '#38bdf8',
    chip: 'border-sky-700/70 bg-sky-900/30 text-sky-200',
  },
  top: {
    label: 'Top',
    sub: 'top third by power',
    color: '#fbbf24',
    chip: 'border-amber-700/70 bg-amber-900/30 text-amber-200',
  },
};

export function formatGrowthPct(n: number | null): string {
  if (n == null) return '—';
  return `${n >= 0 ? '+' : ''}${n.toFixed(1)} %`;
}

/** "141.5 – 177.7 M" — the M-Sum span of a power class. */
export function formatClassRange(min: number | null, max: number | null): string | null {
  if (min == null || max == null) return null;
  return `${min.toFixed(1)} – ${max.toFixed(1)} M`;
}
